import {
    GET_JOURNALS,
    GET_JOURNAL_DETAILS,
    CREATE_JOURNAL,
    UPDATE_JOURNAL,
    DELETE_JOURNAL,
    CLEAR_JOURNAL_STATE,
    CLEAR_JOURNAL_DETAILS,
    CLEAR_JOURNAL_AUDIT_LOGS,
    GET_ACCOUNT_HEADS,
    GET_JOURNAL_AUDIT_LOGS,
    BULK_VALIDATE_JOURNALS,
    BULK_UPLOAD_JOURNALS,
    CLEAR_BULK_IMPORT_STATE,
} from '../../index.types';


export function getJournals(data) {
    return {
        type: GET_JOURNALS,
        data
    }
}

export function getJournalDetails(data) {
    return {
        type: GET_JOURNAL_DETAILS,
        data
    }
}

export function createJournal(data) {
    return {
        type: CREATE_JOURNAL,
        data
    }
}

export function updateJournal(data) {
    return {
        type: UPDATE_JOURNAL,
        data
    }
}

export function deleteJournal(data) {
    return {
        type: DELETE_JOURNAL,
        data
    }
}

export function clearJournalState() {
    return {
        type: CLEAR_JOURNAL_STATE
    }
}

export function getAccountHeads(data) {
    return {
        type: GET_ACCOUNT_HEADS,
        data
    }
}

export function clearJournalDetails() {
    return {
        type: CLEAR_JOURNAL_DETAILS
    }
}

export function clearJournalAuditLogs() {
    return {
        type: CLEAR_JOURNAL_AUDIT_LOGS
    }
}

export function getJournalAuditLogs(data) {
    return {
        type: GET_JOURNAL_AUDIT_LOGS,
        data
    }
}

export function bulkValidateJournals(data) {
    return {
        type: BULK_VALIDATE_JOURNALS,
        data
    }
}

export function bulkUploadJournals(data) {
    return {
        type: BULK_UPLOAD_JOURNALS,
        data
    }
}

export function clearBulkImportState() {
    return {
        type: CLEAR_BULK_IMPORT_STATE
    }
}

export function getChartOfAccountsDropdown(data) {
    return {
        type: 'GET_CHART_OF_ACCOUNTS_DROPDOWN',
        data
    }
}
